<template>
  <main class="order-details" data-testid="order-details">
    <OrderDetailsHeader
      class="order-details__header"
      :head="order.head"
      :subtitle="order.description"
      :symbol="order.instrument.symbol"
      :title="order.title"
      :instrument-type="instrumentType"
    />
    <OrderDetailsContent
      v-for="(content, index) in order.content"
      :key="index"
      class="order-details__content"
      :button-label="buttonLabel"
      :content="content"
      @on-button-click="handleOnButtonClick"
      @on-field-click="handleOnFieldClick"
    />
  </main>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { OrderDetailsContent } from './components/OrderDetailsContent';
import { OrderDetailsHeader } from './components/OrderDetailsHeader';

import { OrderDetailsResponse } from '@/modules/trade/services/orders';
import { OrderTypes } from '@/modules/trade/types';
import * as trackOrderEvents from '@/modules/trade/components/OrderModal/trackers';
import { FieldDetails } from '@/modules/trade/components/OrderModal/types';

@Component({
  components: {
    OrderDetailsContent,
    OrderDetailsHeader
  }
})
export default class OrderDetails extends Vue {
  @Prop({ type: Object, required: true })
  readonly order!: OrderDetailsResponse;

  get instrumentType() {
    return this.order.instrument.type?.value;
  }

  get isPortabilityOrder() {
    return this.order.type?.value === OrderTypes.Portability;
  }

  get buttonLabel() {
    return this.isPortabilityOrder ? 'Editar preço médio' : undefined;
  }

  handleOnFieldClick(fieldData: FieldDetails) {
    this.$emit('on-field-click', fieldData);
    return fieldData;
  }

  handleOnButtonClick() {
    trackOrderEvents.trackOrderDetailEditAveragePrice();
    this.$emit('on-button-click');
  }
}
</script>

<style lang="less" scoped>
.order-details {
  padding: 0 @size-spacing-x600 @size-spacing-x400 @size-spacing-x600;

  &__header {
    margin-bottom: @size-spacing-x700;
  }

  &__content {
    margin-bottom: @size-spacing-x400;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
